// ---------------------------------------------------------------------------
// custom Dropedown
// ---------------------------------------------------------------------------

window.customSelectClickEvent = function () {
    document.querySelectorAll('.js-select-option-dropdown:not(.evt-binded)').forEach(function (element) {
        element.classList.add("evt-binded");
        element.querySelector('.js-select-btn').addEventListener('click', function () {
            this.classList.toggle('select-arrow-active');
        });
        element.querySelectorAll('.js-item').forEach(function (ele) {
            ele.addEventListener('click', function () {
                let mainWrapper = this.closest('.js-select-option-dropdown'),
                    slectBtn = mainWrapper.querySelector('.js-select-btn');
                slectBtn.classList.remove('select-arrow-active');
                let buttonHtml = slectBtn.innerHTML,
                    currentHtml = this.innerHTML;
                this.innerHTML = buttonHtml;

                let mainSelect = mainWrapper.querySelector(mainWrapper.dataset.mainSelect),
                    triggerElement = this.closest(mainWrapper.dataset.triggerEvent) || mainWrapper.querySelector(mainWrapper.dataset.triggerEvent);
                mainSelect.value = this.dataset.value.trim();
                // console.log(triggerElement, mainWrapper.dataset.triggerEvent, this.closest(mainWrapper.dataset.triggerEvent));
                mainSelect.dispatchEvent(new Event('change'));
                slectBtn.innerHTML = currentHtml;
                this.dataset.value = buttonHtml.trim();
            });
        });
    });
};
window.customSelectClickEvent();

// ---------------------------------------------------------------------------
// Timer country zone
//const country_Name = document.querySelectorAll('.js--timer-wrapper');
//country_Name.forEach(function (element) {
//    element.querySelectorAll('.js--timeZone').forEach(function (timeZoneElement) {
//        let timer = timeZoneElement.querySelector('.js--time-text');
//        setInterval(function () {
//            timer.innerText = moment.tz(new Date(), timeZoneElement.dataset.time).format('HH:mm:ss');
//        }, 1000);
//    });
//});

// ---------------------------------------------------------------------------

// ---------------------------------------------------------------------------
// Get Browser Details
// ---------------------------------------------------------------------------
function getBroswerDetails() {
    //Checking the user's OS and Browser
    if ((navigator.userAgent).includes("Android")) {

        document.querySelector("html").classList.add("android");
    } else if ((navigator.userAgent).includes("Mac")) {

        document.querySelector("html").classList.add("mac");
    } else {

        document.querySelector("html").classList.add("windows");
    }


    //-- Browser --//
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isFirefox = typeof InstallTrigger !== 'undefined';
    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
    })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    var isEdge = !isIE && !!window.StyleMedia;
    var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
    var isBlink = (isChrome || isOpera) && !!window.CSS;
    if (isFirefox) {

        document.querySelector("html").classList.add("isFirefox");
    } else if (isChrome) {

        document.querySelector("html").classList.add("isChrome");
    } else if (isSafari) {

        document.querySelector("html").classList.add("isSafari");
    } else if (isOpera) {

        document.querySelector("html").classList.add("isOpera");
    } else if (isIE) {

        document.querySelector("html").classList.add("isIE");
    } else if (isEdge) {

        document.querySelector("html").classList.add("isEdge");
    } else if (isEdgeChromium) {

        document.querySelector("html").classList.add("isEdgeChromium");
    } else {

        document.querySelector("html").classList.add("a");
    }
}
getBroswerDetails();

function swymCallbackFn(swat) {
    //console.log(swat);
    // your API calls go here 
    // detect variant change event
    // Based on your theme code - this event detection may be different - this is only a SAMPLE implementation    
    document.addEventListener("variantChange", function (event) {
        var variantId = event.detail.variant.id; /* the current selected variant id */
        window.triggerSwymVariantEvent(variantId);
        swat.initializeActionButtons(".product-page-wishlist-grid");/* parent container of the where the button is rendered */
    });
    document.addEventListener("swym:collections-loaded", function (event) {
        console.log("Initalizing wishlist buttons", swat, event.detail);
        let parent = '.product-grid';
        if(event.detail){
            if(event.detail.id) parent = `#${event.detail.id} .product-grid`;
        }
        swat.initializeActionButtons(parent);
    })
}
if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

(function () {
    /**
     * Collection Page Swatch Click Handlers
     */
    window._bindCollectionEvents = function _bindCollectionEvents() {
        let productGridSwatch = document.querySelectorAll(".swatch-btn-image");
        let productGridSelectedSwatch = document.querySelectorAll(".color_variants_item.swatch-active .swatch-btn-image");
        if (productGridSwatch.length) {
            productGridSwatch.forEach((swatch) => {
                swatch.addEventListener("click", _handleSwatchClick.bind(this), true);
            });
        }

        if (productGridSelectedSwatch.length) {
            productGridSelectedSwatch.forEach((swatch) => {
                if (swatch.closest('.card__content')) {
                    swatch.closest('.card__content').querySelector('.js-selected-color-label').innerText = swatch.dataset.title;
                }
            });
        }
    }

    window._handleSwatchClick = function _handleSwatchClick(e) {
        let target = e.target || e.currentTarget;
        console.log(target)
        let productObject = target.closest(".swatch-wrapper").querySelector("script[data-json]").innerHTML;
        if (!productObject) return;
        let productJson = JSON.parse(productObject);
        target.closest(".color_variants_main").querySelectorAll(".color_variants_item").forEach((swatchElement) => {
            swatchElement.classList.remove("swatch-active");
        });
        target.closest(".color_variants_item").classList.add("swatch-active");
        //target.closest(".color_variants").querySelector(".js-selected-color-label").innerText = target.dataset.title;
        _handleProduct(target, productJson);
        _handleImageChange(target, productJson);
        _handlePriceChange(target, productJson);
    }

    window._handleProduct = function _handleProduct(target, productJson) {
        target.closest(".card-wrapper").querySelectorAll(".product__link").forEach((element) => {
            element.setAttribute("href", `${window.Shopify.routes.root}products/${productJson.handle}`);
        });
        target.closest(".card-wrapper").querySelector(".card__content .product__link").innerHTML = productJson.title
    }

    window._handleImageChange = function _handleImageChange(target, productJson) {
        let _variantId = parseInt(target.getAttribute("data-variant-id"));
        let selectedVariant;
        for (let variant of productJson.variants) {
            if (variant.id == _variantId) {
                selectedVariant = variant;
            }
        }
        target.closest(".card-wrapper").querySelector(".card__media .media").innerHTML = ""
        let mediaHTML = "";
        let firstMediaSrc = selectedVariant.featured_image ? selectedVariant.featured_image : productJson.media[0].preview_image;
        mediaHTML += `<img class="media__first-image" height="${firstMediaSrc.height}" width="${firstMediaSrc.width}" src="${firstMediaSrc.src}" alt="${firstMediaSrc.alt ? firstMediaSrc.alt : productJson.title}" />`;
        if (productJson.media[1]) {
            mediaHTML += `<img class="media__first-image" height="${productJson.media[1].preview_image.height}" width="${productJson.media[1].preview_image.width}" src="${productJson.media[1].preview_image.src}" alt="${productJson.media[1].preview_image.alt ? productJson.media[1].preview_image.alt : productJson.title}" />`;
        }
        target.closest(".card-wrapper").querySelector(".card__media .media").insertAdjacentHTML("beforeend", mediaHTML);
    }

    window._handlePriceChange = function _handlePriceChange(target, productJson) {
        let _variantId = parseInt(target.getAttribute("data-variant-id"));
        for (let variant of productJson.variants) {
            if (variant.id === _variantId) {
                target.closest(".card-wrapper").querySelector(".price .price__regular .price-item").innerHTML = Shopify.formatMoney(variant.price, Shopify.money_format)
                break;
            }
        }
    }

    /**
     * Product Page Swatch Click Handlers
     */
    window._bindPdpSwatchEvents = function _bindPdpSwatchEvents() {
        const pdpCustomSwatches = document.querySelectorAll(".js-swatch-change");
        if (pdpCustomSwatches.length) {
            pdpCustomSwatches.forEach((swatchElement) => {
                swatchElement.addEventListener("click", _handlePdpSwatchClick.bind(this), true);
            })
        }
    }

    window._handlePdpSwatchClick = function _handlePdpSwatchClick(e) {
        let target = e.currentTarget;
        _handlePdpVariantChange(target);
    }

    window._handlePdpVariantChange = function _handlePdpVariantChange(target) {
        let _optionIndex = target.getAttribute("data-change-option");
        let _selectedOptionTitle = target.getAttribute("data-change-value");
        let _productWrapper = target.closest(".product__info-wrapper");
        let _productOptionSelector = _productWrapper.querySelector(`.select__select[data-option-index='${_optionIndex}']`);
        if (!_productOptionSelector) {
            return;
        }
        _productOptionSelector.querySelectorAll("option").forEach((option) => {
            option.removeAttribute("selected");
        });
        _productOptionSelector.querySelector(`option[value='${_selectedOptionTitle}']`).setAttribute("selected", "selected");
        _productWrapper.querySelector(".color_variants_main_product").querySelectorAll(".color_variants_item").forEach((swatchWrapper) => {
            swatchWrapper.classList.remove("swatch-active");
        });
        target.closest(".color_variants_item").classList.add("swatch-active");

        // Dispatching change event to make the exisiting functionality work
        let evt = new Event('change');
        _productWrapper.querySelector("variant-selects").dispatchEvent(evt);
    }
    _bindCollectionEvents();
    _bindPdpSwatchEvents();

    /**
     * Load More Button Events
     */

    window._handleLoadMoreClick = function _handleLoadMoreClick(evt) {
        console.log(evt);
        let loadMoreBtn = evt.currentTarget;
        loadMoreBtn.setAttribute("disabled", true);
        loadMoreBtn.setAttribute("loading", true);
        let totalPages = parseInt(loadMoreBtn.closest(".shopify-section").querySelector("[data-total-pages]").value);
        let currentPage = parseInt(loadMoreBtn.closest(".shopify-section").querySelector("[data-current-page]").value);
        currentPage = currentPage + 1;
        loadMoreBtn.closest(".shopify-section").querySelector("[data-current-page]").value = currentPage;
        let nextPageURL = loadMoreBtn.closest(".shopify-section").querySelector('[data-next-url]').value.replace(/page=[0-9]+/, 'page=' + currentPage)
        fetch(nextPageURL, { method: "GET", headers: { "Content-type": "application/json; charset=UTF-8" } })
            .then(res => res.text())
            .then((response) => {
                //console.log(response);
                let parser = new DOMParser();
                let newHtml = parser.parseFromString(response, "text/html");
                console.log(loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").querySelector("#article-grid"))
                if(loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").querySelector("#product-grid")){
                loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").querySelector("#product-grid").insertAdjacentHTML("beforeend", newHtml.querySelector("#Huratips-Loop").querySelector("#product-grid").innerHTML);
                }else{
                    loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").querySelector("#article-grid").insertAdjacentHTML("beforeend", newHtml.querySelector("#Huratips-Loop").querySelector("#article-grid").innerHTML);
                }
                loadMoreBtn.removeAttribute("loading");
                if (currentPage <= totalPages) {
                    loadMoreBtn.removeAttribute('disabled');
                }
                if (currentPage == totalPages) {
                    loadMoreBtn.closest(".shopify-section").querySelector(".pagination-wrapper").classList.add("hide");
                    loadMoreBtn.closest(".shopify-section").querySelector(".load-more_wrap").classList.add("hide");
                    loadMoreBtn.closest(".shopify-section").querySelector("#product-grid").classList.add("tw-mb-8");
                }
                QuickShop.prototype.bindBtnEvents();
                _bindCollectionEvents();
                document.dispatchEvent(new CustomEvent('swym:collections-loaded', { bubbles: true }));
            });
    }

    window._bindLoadMoreEvents = function _bindLoadMoreEvents() {
        let loadMoreButtons = document.querySelectorAll(".js-load-more");
        loadMoreButtons.forEach((loadMoreButton) => {
            // console.log(loadMoreButton);
            loadMoreButton.addEventListener("click", window._handleLoadMoreClick.bind(this), true);
        });
    }
    _bindLoadMoreEvents();

})();